export const containsPhoneNumber = (value: string): boolean => {
  if (!value) return false

  // enlève tout sauf chiffres et +
  const normalized = value.replace(/[^\d+]/g, '')

  // patterns téléphone FR + international simple
  const phoneRegex = /^(\+?\d{1,3})?\d{9,}$/ // +33XXXXXXXXX ou 0XXXXXXXXX etc.

  // ou présence d’au moins 6 chiffres (sécurité)
  const hasTooManyDigits = (value.match(/\d/g) || []).length >= 6

  return phoneRegex.test(normalized) || hasTooManyDigits
}
